import React from 'react';
import {useSelector} from 'react-redux';
import {Container} from '@mui/material';
import TravelMode from './TravelMode';
import PermissionCheck from '../../Components/PermissionCheck';
import Consents from './Consents';

const ConsentsTab = () => {
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);
    const currentSchool = useSelector(state => state.profilesInfo.currentSchool);

    return (
        <Container
            xs={12}
            sm={12}
            sx={{
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <PermissionCheck
                permissionModule="StudentConsents"
                render={(readonly) => <Consents
                    readonly={readonly}
                    school={currentSchool}
                    profile={selectedProfile}
                />}
            />
            <PermissionCheck
                permissionModule="StudentTravelMode"
                render={(readonly) => <TravelMode
                    readonly={readonly}
                    school={currentSchool}
                    profile={selectedProfile}
                />}
            />
        </Container>
    );
};

export default ConsentsTab;
